<script>
/**
 * A visão COMPACTA do índice "Artefatos desta conversa": uma régua vertical
 * de ícones (`LARGURA_DA_REGUA`, 40px — print de referência do usuário,
 * 14/09/2026) — no topo o chevron `<` "Expandir" (abre o menu: na faixa se
 * cabe, POR CIMA do chat se não), depois um TILE quadrado por artefato
 * (`LADO_DO_TILE_DA_REGUA` 28, raio `--radius-sm` — a proporção do menu,
 * ícone 16) com o ícone do módulo em `primary` sobre o wash 6% de `primary`;
 * o ATIVO é a receita do tile do `artefato-preview-card`: `primary` sólido +
 * ícone branco. Gap de 8px. ★ No máximo `MAX_TILES_VISIVEIS` (5) tiles
 * visíveis — o resto rola por dentro, com a scrollbar FINA da lateral
 * (trilho transparente, polegar `--sidebar-warm-border`, 4px) e
 * `scrollbar-gutter: stable both-edges`, para os tiles não pularem de lado
 * quando a barra entra (print do usuário: a barra global de 7px deslocava
 * a coluna). Sem rodapé: a régua É o estado mínimo do índice (desde
 * 14/09/2026 — não há para onde minimizar). O título inteiro vai no
 * `v-tooltip` à esquerda (e no `aria-label`). Sem cabeçalho de texto: a
 * contagem vai no `aria-label` da régua.
 *
 * ★ É a visão de quando NÃO cabe menu ao lado do trilho (faixa livre medida
 * pelo `messages.vue` < `PISO_DO_CARTAO_CONDENSADO`; a 1366px com a lateral
 * da imersiva aberta o trilho ocupa o container inteiro) E a de quem
 * minimizou o menu (preferência de régua). Decisão do usuário em 14/09/2026:
 * a régua cobre no máximo 40px da bolha (`LARGURA_DA_REGUA`) e continua um
 * índice clicável. O pai a monta por
 * `visaoEfetiva === VISOES_DO_INDICE.compacta`.
 *
 * Componente BURRO, como a completa: recebe as `linhas` decoradas do pai e
 * emite `abrir(linha)` / `fechar` (o MESMO toggle do aside — linha JÁ ativa
 * fecha) e `expandir`. Hover escurece o wash (6% → 12%); ícone
 * animado no hover pelo MESMO partial `_nav-icon-tells.sass` do menu (hover
 * por JS, `linhaEmHover`, como o pai).
 *
 * O visual do cartão (hairline, sombra, raio, fundo) vem da classe
 * `chat-indice-artefatos__cartao` que o pai passa no root — o `<style
 * scoped>` dele alcança o root do filho. Aqui mora só o que é da régua.
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila). Acentos UTF-8 reais.
 */
import { INDICE_ARTEFATOS } from '@modules/aawz-intelligence-v2/constants/TextChat'
import {
  GAP_ENTRE_TILES_DA_REGUA,
  ICONE_DE_EXPANDIR,
  LADO_DO_TILE_DA_REGUA,
  LARGURA_DA_REGUA,
  RESPIRO_DO_TOPO,
  TAMANHO_DO_BOTAO_DO_TOPO,
  alturaMaximaDaListaDaRegua,
  TAMANHO_DO_ICONE_DA_LINHA,
  TAMANHO_DO_ICONE_DO_TOPO,
} from './chat-indice-artefatos.constantes'

export default {
  name: 'IntelligenceV2ChatIndiceArtefatosCompacta',
  props: {
    // `[{identidade, titulo, icone, parteReal, ativa, iconeDetalhado}]` — o
    // computed `linhas` do `chat-indice-artefatos.vue`.
    linhas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ICONE_DE_EXPANDIR,
      TAMANHO_DO_ICONE_DA_LINHA,
      TAMANHO_DO_ICONE_DO_TOPO,
      rotuloExpandir: INDICE_ARTEFATOS.EXPANDIR,
      linhaEmHover: null,
    }
  },
  computed: {
    // "Entregas desta conversa — N entregas": a contagem que o menu mostra
    // no cabeçalho, aqui só para o leitor de tela.
    rotulo() {
      return INDICE_ARTEFATOS.ROTULO_ACESSIVEL(this.linhas.length)
    },
    // Geometria em custom properties: o `<style>` consome `var(--regua-*)`,
    // então tile, gap e teto vêm de UMA fonte (as constantes).
    estilo() {
      return {
        width: LARGURA_DA_REGUA + 'px',
        // O chevron no MESMO x/y do botão do menu (`RESPIRO_DO_TOPO`): o topo
        // é o `cima`; a direita sai sozinha do botão centrado nos 40px.
        paddingTop: RESPIRO_DO_TOPO.cima + 'px',
        '--regua-tile': LADO_DO_TILE_DA_REGUA + 'px',
        '--regua-gap': GAP_ENTRE_TILES_DA_REGUA + 'px',
        '--regua-botao': TAMANHO_DO_BOTAO_DO_TOPO + 'px',
      }
    },
    estiloDaLista() {
      return { maxHeight: alturaMaximaDaListaDaRegua() + 'px' }
    },
  },
  methods: {
    classesDoIcone(linha) {
      return {
        'is-detailed': linha.iconeDetalhado,
        'is-animating': this.linhaEmHover === linha.identidade,
      }
    },
    // O tile ativo é `primary` sólido: o ícone precisa virar branco.
    corDoIcone(linha) {
      return linha.ativa ? 'var(--white)' : 'primary'
    },
    escolher(linha) {
      if (linha.ativa) {
        this.$emit('fechar')
        return
      }
      this.$emit('abrir', linha)
    },
    expandir() {
      this.$emit('expandir')
    },
  },
}
</script>

<template>
  <!-- <nav>: a régua é uma navegação entre as entregas (Sonar Web:S6819
       reprova `role="group"` num div). Sem ancestral <aside>, a regra global
       `aside nav` de `design/components/_aside.sass` não alcança. -->
  <nav
    class="chat-indice-artefatos-compacta d-flex flex-column align-center"
    :style="estilo"
    :aria-label="rotulo"
    data-test="chat-indice-artefatos-compacta"
  >
    <!-- Topo: o chevron do print — abre o menu (na faixa, ou por cima). -->
    <button
      type="button"
      class="chat-indice-artefatos-compacta__acao d-inline-flex align-center justify-center flex-shrink-0 mb-1"
      :aria-label="rotuloExpandir"
      :title="rotuloExpandir"
      data-test="chat-indice-artefatos-compacta-expandir"
      @click="expandir"
    >
      <icon-svg
        :name="ICONE_DE_EXPANDIR"
        :size="TAMANHO_DO_ICONE_DO_TOPO"
        color="var(--neutral-600)"
      />
    </button>
    <ul
      class="chat-indice-artefatos-compacta__lista d-flex flex-column align-center"
      :style="estiloDaLista"
      data-test="chat-indice-artefatos-compacta-lista"
    >
      <li v-for="linha in linhas" :key="linha.identidade">
        <!-- Só `aria-label` + tooltip, sem `title`: os dois juntos mostram
             DOIS balões (o nativo e o do Vuetify) ao mesmo tempo. -->
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <button
              v-bind="attrs"
              type="button"
              class="chat-indice-artefatos-compacta__tile d-inline-flex align-center justify-center"
              :aria-label="linha.titulo"
              :aria-current="linha.ativa ? 'true' : null"
              data-test="chat-indice-artefatos-compacta-botao"
              v-on="on"
              @click="escolher(linha)"
              @mouseenter="linhaEmHover = linha.identidade"
              @mouseleave="linhaEmHover = null"
            >
              <icon-svg
                class="navbar-main-icon"
                :class="classesDoIcone(linha)"
                :name="linha.icone"
                :size="TAMANHO_DO_ICONE_DA_LINHA"
                :color="corDoIcone(linha)"
              />
            </button>
          </template>
          <span>{{ linha.titulo }}</span>
        </v-tooltip>
      </li>
    </ul>
  </nav>
</template>

<style lang="sass" scoped>
// O MESMO mapa de animação por ícone do menu/navbar (ver o cabeçalho).
@import '@modules/navegacao-v2/styles/_nav-icon-tells.sass'

// Geometria do print, reduzida (14/09/2026): tile `--regua-tile` (28) com
// `--radius-sm`, gap `--regua-gap` (8), 6px de respiro em volta — 28 + 12 =
// a `LARGURA_DA_REGUA` (40). As custom properties vêm do `estilo` (constantes).
$respiro-da-regua: 6px
$largura-da-scrollbar: 4px

// `padding-top` é inline (`RESPIRO_DO_TOPO.cima`, o mesmo do cabeçalho do menu).
.chat-indice-artefatos-compacta
  padding: 0 0 $respiro-da-regua

// A lista rola por dentro (teto inline: `MAX_TILES_VISIVEIS`). Scrollbar
// FINA, a receita da lateral (`chat-sidebar.vue::__corpo`): trilho
// transparente, polegar quente, 4px — a global de 7px (`design/index.sass`)
// deslocava os tiles. `scrollbar-gutter: stable both-edges` reserva a calha
// dos DOIS lados sempre, então os tiles ficam centrados com ou sem barra.
.chat-indice-artefatos-compacta__lista
  list-style: none
  margin: 0
  padding: 0
  gap: var(--regua-gap)
  width: 100%
  overflow-y: auto
  // `auto` no eixo Y arrasta o X: no Firefox a calha `thin` (~8px de cada
  // lado) deixa menos que 28px para o tile e nasceria uma barra horizontal.
  overflow-x: hidden
  scrollbar-gutter: stable both-edges
  // ⚠️ SEM as propriedades padrão de barra (width/color): com elas o Chrome
  // ignora o `::-webkit-scrollbar` e desenha a barra nativa grossa, com setas
  // (print do usuário, 14/09/2026). Firefox fica com a barra padrão dele —
  // aceito (o `@supports selector()` quebra o autoprefixer deste repo).
  &::-webkit-scrollbar
    width: $largura-da-scrollbar

  &::-webkit-scrollbar-track
    background: transparent

  &::-webkit-scrollbar-thumb
    background: var(--sidebar-warm-border)
    box-shadow: none

    &:hover
      background: var(--neutral-300)

.chat-indice-artefatos-compacta__acao
  width: var(--regua-botao)
  height: var(--regua-botao)
  border: 0
  border-radius: var(--radius-sm)
  background: transparent
  cursor: pointer

  &:hover,
  &:focus-visible
    background: var(--sidebar-warm-hover)
    outline: 0

// O tile: o wash é o FUNDO de todos (print), mais leve que o do card (6%);
// o ativo é a receita do tile do `artefato-preview-card` (`primary` sólido,
// ícone branco pelo `corDoIcone`). `color-mix`, nunca rgba cru.
.chat-indice-artefatos-compacta__tile
  width: var(--regua-tile)
  height: var(--regua-tile)
  border: 0
  border-radius: var(--radius-sm)
  background: color-mix(in srgb, var(--primary) 6%, var(--white))
  cursor: pointer
  transition: background var(--motion-duration-fast) var(--motion-easing-standard)

  &:hover
    background: color-mix(in srgb, var(--primary) 12%, var(--white))

  &:focus-visible
    outline: 2px solid var(--primary)
    outline-offset: 2px

  &[aria-current="true"],
  &[aria-current="true"]:hover
    background: var(--primary)
</style>
